.stepper {
  display: inline-flex;
  align-items: center;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  color: var(--accent);
  background-color: color-mix(in srgb, var(--accent) 20%, transparent);
  border: 1px solid color-mix(in srgb, var(--accent) 40%, transparent);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.button:hover {
  background-color: color-mix(in srgb, var(--accent) 30%, transparent);
  border-color: var(--accent);
}

.button:active {
  background-color: color-mix(in srgb, var(--accent) 40%, transparent);
}

.md {
  gap: 6px;
}
.md .button {
  width: 22px;
  height: 22px;
  font-size: 14px;
}

.sm {
  gap: 4px;
}
.sm .button {
  width: 18px;
  height: 18px;
  font-size: 12px;
}
